export default __webpack_public_path__ + "static/media/logo.438c6ffd.webp";